import usePluginEntities from "hooks/usePluginEntities";
import "./types";
export const useInputTitleLinkBuilder = () => {
  const builders = usePluginEntities("inputTitleLinks");
  return (resolved) => {
    const builder = builders.find((b) => b.type === resolved.type);
    return builder ? builder.buildPath(resolved) : null;
  };
};
